import { render, staticRenderFns } from "./InlineAddonCard.vue?vue&type=template&id=e7b54714&"
import script from "./InlineAddonCard.vue?vue&type=script&lang=js&"
export * from "./InlineAddonCard.vue?vue&type=script&lang=js&"
import style0 from "./InlineAddonCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports